const auth = {
    'auth.register': 'Registreren',

    'auth.login': 'Inloggen',
    'auth.login_as': 'Inloggen als',
    'auth.login_as.reseller': 'Inloggen als reseller',
    'auth.login_as.client': 'Inloggen als klant',
    'auth.login.error': 'Verkeerde combinatie van e-mailadres en wachtwoord!',
    'auth.login.sub.error': 'Het account is nog niet geactiveerd. Er is een email gestuurd naar het e-mailadres die bekend is bij ons.',

    'auth.logout': 'Uitloggen',

    'auth.forgot_password': 'Wachtwoord vergeten',
    'auth.forgot_password.explanation': 'Vul hieronder je e-mailadres in. We sturen je een e-mail met een link waarmee je een nieuw wachtwoord kan instellen.',
    'auth.forgot_password.ok': 'Wachtwoord reset email is met succes verstuurd!',
    'auth.forgot_password.error': 'E-mailadres wordt niet herkend.',

    'auth.reset_password': 'Wachtwoord resetten',
    'auth.reset_password.ok': 'Je wachtwoord is succesvol aangepast!',
    'auth.reset_password.error': 'Er is iets misgegaan met het aanpassen van je wachtwoord.',

    'auth.send_password': 'Verstuur wachtwoord',

    'auth.back_to_login': 'Terug naar inloggen',

    'auth.my_account': 'Mijn account',
};

export default auth;
